import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGElement from './SVGElement';

export default class Heart extends Component {
  static propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    strokeColor: PropTypes.string,
    fillColor: PropTypes.string,
    width: PropTypes.string,
  };

  static defaultProps = {
    height: '1.5rem',
    fillColor: 'none',
    strokeColor: '#979797',
    width: '1.5rem',
  };

  render() {
    const { className, height, strokeColor, fillColor, width } = this.props;

    return (
      <SVGElement
        className={className}
        height={height}
        viewBox="0 0 24 24"
        width={width}
      >
        <path
          className="svg-heart-fill"
          fill={fillColor}
          d="M12,20a.17.17,0,0,1-.12,0L4.33,12.09a4.72,4.72,0,0,1-1-1.55,4.88,4.88,0,0,1,1-5.17,4.45,4.45,0,0,1,1.6-1.06,4.35,4.35,0,0,1,4.79,1.06L12,6.71l1.27-1.32a4.4,4.4,0,0,1,6.4,0,4.89,4.89,0,0,1,0,6.72L12.11,20A.17.17,0,0,1,12,20Z"
        />
        <path
          className="svg-heart-stroke"
          fill={strokeColor}
          d="M7.53,4.5a3.91,3.91,0,0,1,2.84,1.22l.92,1,.72.75.72-.75.9-.94a3.9,3.9,0,0,1,5.67,0,4.39,4.39,0,0,1,0,6l-3.82,4-2.64,2.74-.45.47-.4.41L11,18.3,4.69,11.75a4.23,4.23,0,0,1-.88-1.39,4.38,4.38,0,0,1,.88-4.64,4,4,0,0,1,1.42-.95A3.87,3.87,0,0,1,7.53,4.5m0-1a4.88,4.88,0,0,0-1.78.35A5,5,0,0,0,4,5a5.4,5.4,0,0,0-1.09,5.7A5.24,5.24,0,0,0,4,12.44L10.25,19l1.26,1.32a.68.68,0,0,0,1,0l1.09-1.14L20,12.45A5.4,5.4,0,0,0,20,5a4.9,4.9,0,0,0-7.12,0L12,6l-.92-1A4.92,4.92,0,0,0,7.53,3.5Z"
        />
      </SVGElement>
    );
  }
}
